import { createContext } from "react";

export const SelectedVendorDetailsContext = createContext(null);
